module.exports = __webpack_public_path__ + "img/la.c66d1ff3.png";